import {
  FC,
  PropsWithChildren,
  createContext,
  useContext,
  useMemo,
} from "react";
import { ScoreAPI, ScoreData } from "../Score";
import { useScoreReducer } from "./ScoreReducer";

//  CONTEXTS
export const ScoreAPIContext = createContext({} as ScoreAPI);
export const ScoreDataContext = createContext({} as ScoreData);

export const ScoreProvider: FC<PropsWithChildren> = ({ children }) => {
  console.info("ScoreProvider render");

  //  DATA REDUCER
  const { data, dispatch } = useScoreReducer();

  //  API
  const api = useMemo<ScoreAPI>(() => {
    const completePOI = (poiId: string) => {
      dispatch({ type: "completePOI", poiId });
    };
    const unlockAllChapters = () => {
      if (process.env.REACT_APP_DEV_MODE === "true") {
        dispatch({ type: "unlockAllChapter" });
      }
    };
    return { completePOI, unlockAllChapters };
  }, [dispatch]);

  return (
    <ScoreAPIContext.Provider value={api}>
      <ScoreDataContext.Provider value={data}>
        {children}
      </ScoreDataContext.Provider>
    </ScoreAPIContext.Provider>
  );
};

//  CUSTOM HOOKS
export const useScoreAPI = () => useContext(ScoreAPIContext);
export const useScoreData = () => useContext(ScoreDataContext);
